import { Box, Button, Flex, Heading } from "@chakra-ui/react"
import React from "react"
import _ from "lodash"
import GuideCard from "./GuideCard"
import Grid from "../../common/components/Grid"
import Cell from "../../common/components/Cell"
import AreaCard from "./AreaCard"
import GymCard from "../../gyms/components/GymCard"
import ProblemCard from "./ProblemCard"
import RouteCard from "./RouteCard"
import NextLink from "next/link"
import FeaturesMapList from "./FeaturesMapList"
import Tabs from "../../common/components/Tabs"
import { useRouter } from "next/router"
import { clearQueries, setQueryParam } from "../../utilities/queryParams"
import GradeContext from "../../context/GradeContext"

function getFeatureList({ features, title, CardComponent }) {
  return (
    <Box mt={5}>
      <Heading size="lg" as="h3">
        {title}
      </Heading>
      <Grid>
        {features.map((feature) => (
          <Cell col={3} key={feature._id}>
            <CardComponent {...{ [feature.type]: feature }} />
          </Cell>
        ))}
      </Grid>
    </Box>
  )
}

const NearbyList = ({ features }) => {
  const router = useRouter()
  const [curFeatureType, setCurrentFeatureType] = React.useState("problems")
  const groupedFeatures = _.groupBy(
    features.filter((f) => !!f?.type),
    (feat) => feat.type,
  )
  const hasProblems = !!groupedFeatures.problem?.length
  const hasRoutes = !!groupedFeatures.route?.length
  const hasClimbs = hasProblems && hasRoutes

  return (
    <Box mt={"60px"} mx={6}>
      {groupedFeatures.gym?.length &&
        getFeatureList({
          features: _.sortBy(groupedFeatures.gym, (obj) => obj.name),
          title: "Gyms",
          CardComponent: GymCard,
        })}
      {groupedFeatures.guide?.length &&
        getFeatureList({
          features: _.sortBy(groupedFeatures.guide, (obj) => obj.name),
          title: "Guides",
          CardComponent: GuideCard,
        })}
      {groupedFeatures.area?.length &&
        getFeatureList({
          features: _.sortBy(groupedFeatures.area, (obj) => obj.name),
          title: "Areas",
          CardComponent: AreaCard,
        })}
      {!!hasClimbs ? (
        <Box mt={10}>
          <Tabs
            tabsAr={[
              {
                name: "Routes",
                value: "routes",
              },
              {
                name: "Boulders",
                value: "problems",
              },
            ]}
            curTab={curFeatureType}
            onTabChange={(type) => {
              setCurrentFeatureType(type)
              clearQueries(router)
              setQueryParam("curFeatureType", type, router)
            }}
          />
        </Box>
      ) : (
        <Box mt={10}>
          {!!hasProblems && (
            <Heading as="h3" size="lg">
              Problems
            </Heading>
          )}
          {!!hasRoutes && (
            <Heading as="h3" size="lg">
              Routes
            </Heading>
          )}
        </Box>
      )}

      {(hasProblems || hasRoutes) && (
        <GradeContext.Consumer>
          {(gradeType) => (
            <FeaturesMapList
              gradeType={gradeType}
              curFeatureType={curFeatureType}
              mainFeatures={
                curFeatureType === "problems"
                  ? groupedFeatures.problem
                  : groupedFeatures.route
              }
              isIndoor
            />
          )}
        </GradeContext.Consumer>
      )}
      <Flex justifyContent="center" mt={10}>
        <NextLink shallow href="/map?view=map" passHref>
          <Button raised="true" variant="primary" size="lg">
            Back to the map
          </Button>
        </NextLink>
      </Flex>
    </Box>
  )
}

export default NearbyList
